<template>
	<div class="user-integral-container">
		<el-row :gutter="20">

			<el-col :span="21">
				<el-card class="box-card">
					<div slot="header" class="clearfix text-left">
						<span>{{ $t('userIntegral.search.title') }}</span>
					</div>
					<el-form :inline="true" :model="searchForm" class="search-form  text-left">
						<el-form-item :label="$t('userIntegral.search.integralName')">
							<el-input v-model="searchForm.typeName"
								:placeholder="$t('userIntegral.search.integralNamePlaceholder')" clearable />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="handleSearch">
								{{ $t('common.search') }}
							</el-button>
						</el-form-item>
					</el-form>
				</el-card>

				<el-card class="box-card">
					<div slot="header" class="clearfix  text-left">
						<span>{{ $t('userIntegral.list.title') }}</span>
						<div style="float: right;">
							<el-button type="primary" size="small" @click="handleAdd">
								{{ $t('common.add') }}
							</el-button>
						</div>
					</div>
					<el-table v-loading="loading" :data="tableData" border style="width: 100%">
						<el-table-column prop="id" :label="$t('userIntegral.table.id')" align="center" />
						<el-table-column prop="typeName" :label="$t('userIntegral.table.typeName')" align="center" />

						<el-table-column prop="caozuo" :label="$t('userIntegral.table.caozuo')" align="center" />
					</el-table>
					<pagination :current-page="pagination.current" :page-size="pagination.size"
						:total="pagination.total" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" />
				</el-card>
			</el-col>
		</el-row>
		<add-goods-type ref="AddGoodsType" @success="handleSuccess" />
	</div>

</template>

<script>
	import {
		queryIntegralList
	} from '@/api/mall/userIntegralApi'
	import Pagination from '@/components/mall/Pagination'
	import {
		jumpToMall
	} from '@/api/user/menuApi'
	import AddGoodsType from '@/components/mall/AddGoodsType'

	export default {
		name: 'UserIntegralList',
		components: {
			Pagination,
			AddGoodsType
		},
		data() {
			return {
				loading: false,
				integralTypes: [{
						value: '6006',
						label: 'personal'
					},
					{
						value: '7007',
						label: 'merchant'
					}
				],
				searchForm: {
					typeName: '',
					// objType: '6006',
					// mallApiCode: 'queryIntegralBmoImpl'
				},
				tableData: [],
				pagination: {
					current: 1,
					size: 10,
					total: 0
				}
			}
		},
		created() {
			this.getList()
		},
		methods: {
			async getList() {
				try {
					this.loading = true
					const params = {
						page: this.pagination.current,
						row: this.pagination.size,
						...this.searchForm
					}
					const {
						data,
						total
					} = await queryIntegralList(params)
				
					this.tableData = data
					this.pagination.total = total
				} catch (error) {
					this.$message.error(this.$t('userIntegral.fetchError'))
				} finally {
					this.loading = false
				}
			},
			handleSearch() {
				this.pagination.current = 1
				this.getList()
			},
			handleManage() {
				const path = this.searchForm.objType === '6006' ?
					'/#/pages/admin/userIntegral' :
					'/#/pages/admin/storeIntegral'
				// this.$router.push({ path })
				jumpToMall(path)
			},
			switchIntegralType(type) {
				this.searchForm.objType = type
				this.handleSearch()
			},
			handleSizeChange(val) {
				this.pagination.size = val
				this.getList()
			},
			handleCurrentChange(val) {
				this.pagination.current = val
				this.getList()
			},
			handleAdd() {
				this.$refs.AddGoodsType.open()
			},
			handleSuccess() {
				this.getList()
			},
		}
	}
</script>

<style lang="scss" scoped>
	.user-integral-container {
		padding: 20px;

		.box-card {
			margin-bottom: 20px;
		}

		.type-selector {
			.type-list {
				list-style: none;
				padding: 0;
				margin: 0;

				.type-item {
					padding: 10px;
					text-align: center;
					cursor: pointer;
					border-radius: 4px;
					margin-bottom: 5px;
					transition: all 0.3s;

					&:hover {
						background-color: #f5f7fa;
					}

					&.active {
						background-color: #409eff;
						color: white;
					}
				}
			}
		}

		.search-form {
			margin-bottom: -18px;
		}
	}
</style>